import { SAVED_COLOR_PROPS_TO_IGNORE } from './constants';

export const filterSavedColors = (savedColors = []) => {
  // We want to ignore changes to local colors that are being edited
  return savedColors.filter(
    (savedColor) => !savedColor.isLocal || savedColor.shouldSync
  );
};

export const deleteKeysFromSavedColor = (savedColor) => {
  const newSavedColor = {};

  for (const key of Object.keys(savedColor)) {
    const value = savedColor[key];

    if (SAVED_COLOR_PROPS_TO_IGNORE.includes(key)) {
      continue;
    }

    newSavedColor[key] = value;
  }

  return newSavedColor;
};

export const deleteKeysFromSavedColors = (savedColors = []) => {
  return filterSavedColors(savedColors).map(deleteKeysFromSavedColor);
};
